import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { datasetUrl } from '@/constants/urls';
import { states } from '@/constants/lifecycle';
import Selectors from '../hooks/selectors';

const DataManagementPanelHeader = ({
  className,
  code,
  onChange,
  url,
}) => {
  const intl = useIntl();
  const { name, readStatus } = Selectors.useDataManagementPanelHeader(code);
  const isLoading = readStatus === states.PENDING;
  if (onChange && readStatus === states.SUCCESS) {
    const title = intl.formatMessage({ id: 'tabs.data.management.of' }, { name });
    onChange({ url, title });
  }

  return (
    <Header
      as="a"
      href={datasetUrl({ code }, '#')}
      color="blue"
      className={clsx('aridhia-dataset-data-management-panel-header aridhia-h2', className)}
      rel="noopener noreferrer"
    >
      <Icon loading={isLoading} name={isLoading ? 'circle notch' : 'database'} className="primary" />
      <Header.Content content={intl.formatMessage({ id: 'tabs.data.management.of' }, { name })} />
    </Header>
  );
};

export default DataManagementPanelHeader;
